import { UserPublic } from "@/app/_lib/types/user.types";
import type { Session } from "next-auth";

export const getUserNameDisplay = (
  user?: UserPublic | { firstName?: string | null; lastName?: string | null; username?: string | null; email?: string; emailAddresses?: Array<{ emailAddress: string }> } | NonNullable<Session["user"]>
) => {
  if (!user) return "User";

  return (
    (user && "name" in user && user.name) ||
    (user && "firstName" in user && !!user.firstName &&
      "lastName" in user && !!user.lastName &&
      `${
        user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1)
      } ${user.lastName.charAt(0).toUpperCase()}.`) ||
    (user && "firstName" in user && !!user.firstName &&
      `${user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1)}`) ||
    (user && "username" in user && user.username && `un${user.username}`) ||
    (user && "email" in user && user.email && user.email.split("@")[0]) ||
    (user &&
      "emailAddresses" in user &&
      user.emailAddresses &&
      user.emailAddresses[0].emailAddress.split("@")[0]) ||
    "User"
  );
};
